<script setup lang="ts">
import CBaseBlock from '@/presentation/components/base/CBaseBlock.vue'
import type School from '@/core/domain/school/core/School.ts'
import { default as PButton } from 'primevue/button'
import { SchoolType } from '@/core/domain/resources/enums/SchoolType.ts'

const props = defineProps<{
  school: School | undefined
}>()
</script>

<template>
  <c-base-block :toggleable="false" title="Informations de l'établissement">
    <div class="flex grid-cols-12 flex-col gap-4" v-if="school">
      <div class="flex flex-col gap-2">
        <p class="font-semibold">Code établissement</p>
        <p>{{ school.codeUai ?? 'non renseigné' }}</p>
      </div>

      <div class="flex flex-col gap-2">
        <p class="font-semibold">Nom de l'établissement</p>
        <p>{{ school.name }}</p>
      </div>

      <div class="flex flex-col gap-2">
        <p class="font-semibold">Adresse email</p>
        <p>{{ school.contactEmail ?? 'non renseigné' }}</p>
      </div>

      <div class="flex flex-col gap-2">
        <p class="font-semibold">Adresse</p>
        <p>{{ school.address ?? 'non renseigné' }}</p>
      </div>

      <div class="flex flex-col gap-2">
        <p class="font-semibold">Ville</p>
        <p>{{ school.city ?? 'non renseigné' }}</p>
      </div>

      <div class="flex flex-col gap-2">
        <p class="font-semibold">Code postal</p>
        <p>{{ school.zipCode ?? 'non renseigné' }}</p>
      </div>

      <div class="flex flex-col gap-2">
        <p class="font-semibold">Département</p>
        <p>{{ school.department ?? 'non renseigné' }}</p>
      </div>

      <div class="flex flex-col gap-2">
        <p class="font-semibold">Académie</p>
        <p>{{ school.schoolDistrict ?? 'non renseigné' }}</p>
      </div>

      <div class="flex flex-col gap-2">
        <p class="font-semibold">Type</p>
        <p>{{ SchoolType.label(school.schoolType) }}</p>
      </div>

      <div>
        <p-button
          label="Modifier l'établissement"
          outlined
          size="small"
          @click="$router.push({ name: 'schools-update', params: { schoolSlug: school.slug } })"
          severity="primary"
        />
      </div>
    </div>

    <p v-else>Aucune information disponible</p>
  </c-base-block>
</template>
